import { get, post, put } from "./api_helper"

const getList = () => get(`admin/master/user/staff/list`)


const StaffAPI = {
  getList
}

export default StaffAPI